import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
//import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux/store";
import { Auth0Provider } from '@auth0/auth0-react';
import "./index.css";

/*if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  (whyDidYouRender)(React, {
    trackAllPureComponents: true,
    trackHooks: true,
    logOwnerReasons: true,
  });
}*/

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// Clear any accidental leftover auth flags on root mount
// but NOT during the middle of a redirect callback (handled by Auth0Provider)
if (!window.location.pathname.includes('/callback')) {
  sessionStorage.removeItem('is_logging_out');
  sessionStorage.removeItem('auth_redirect_in_progress');
}

root.render(
  <Auth0Provider
    domain={process.env.REACT_APP_AUTH0_DOMAIN || ''}
    clientId={process.env.REACT_APP_AUTH0_CLIENT_ID || ''}
    authorizationParams={{
      redirect_uri: window.location.origin + '/callback',
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      scope: 'openid profile email offline_access',
    }}
    cacheLocation="localstorage"
    useRefreshTokens={true}
    skipRedirectCallback={false}
    onRedirectCallback={(appState) => {
      // Get the returnTo path from appState or default to /search
      const returnTo = appState?.returnTo || '/';

      // Clean up session storage
      sessionStorage.removeItem('auth_redirect_in_progress');
      sessionStorage.removeItem('is_logging_out');

      // Use window.location.href for the redirect
      // This ensures a full page reload and proper state initialization
      window.location.href = returnTo;
    }}
  >
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider> 
  </Auth0Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
